import { useState, useCallback } from 'react';

export function useAnalysisData() {
  const [cruxData, setCruxData] = useState(null);
  const [lighthouseData, setLighthouseData] = useState(null);
  const [labData, setLabData] = useState(null);
  const [historyData, setHistoryData] = useState(null);
  const [monthlyData, setMonthlyData] = useState(null);
  const [formFactorFractions, setFormFactorFractions] = useState(null);
  const [lcpImageSubparts, setLcpImageSubparts] = useState(null);
  const [navigationTypes, setNavigationTypes] = useState(null);
  const [lcpResourceType, setLcpResourceType] = useState(null);
  const [apiStatus, setApiStatus] = useState(null);
  const [collectionPeriod, setCollectionPeriod] = useState(null);
  const [currentMetrics, setCurrentMetrics] = useState(null);
  const [historicalData, setHistoricalData] = useState(null);
  const [periodsData, setPeriodsData] = useState(null);

  const resetAnalysisData = useCallback(() => {
    setCruxData(null);
    setLighthouseData(null);
    setLabData(null);
    setHistoryData(null);
    setMonthlyData(null);
    setFormFactorFractions(null);
    setLcpImageSubparts(null);
    setNavigationTypes(null);
    setLcpResourceType(null);
    setApiStatus(null);
    setCollectionPeriod(null);
    setCurrentMetrics(null);
    setHistoricalData(null);
    setPeriodsData(null);
  }, []);

  const setAnalysisResults = useCallback((results) => {
    if (results.cruxData !== undefined) setCruxData(results.cruxData);
    if (results.lighthouseData !== undefined) setLighthouseData(results.lighthouseData);
    if (results.historyData !== undefined) setHistoryData(results.historyData);
    if (results.monthlyData !== undefined) setMonthlyData(results.monthlyData);
    if (results.formFactorFractions !== undefined) setFormFactorFractions(results.formFactorFractions);
    if (results.lcpImageSubparts !== undefined) setLcpImageSubparts(results.lcpImageSubparts);
    if (results.navigationTypes !== undefined) setNavigationTypes(results.navigationTypes);
    if (results.lcpResourceType !== undefined) setLcpResourceType(results.lcpResourceType);
    if (results.apiStatus !== undefined) setApiStatus(results.apiStatus);
    if (results.collectionPeriod !== undefined) setCollectionPeriod(results.collectionPeriod);
  }, []);

  return {
    cruxData, setCruxData,
    lighthouseData, setLighthouseData,
    labData, setLabData,
    historyData, setHistoryData,
    monthlyData, setMonthlyData,
    formFactorFractions, setFormFactorFractions,
    lcpImageSubparts, setLcpImageSubparts,
    navigationTypes, setNavigationTypes,
    lcpResourceType, setLcpResourceType,
    apiStatus, setApiStatus,
    collectionPeriod, setCollectionPeriod,
    currentMetrics, setCurrentMetrics,
    historicalData, setHistoricalData,
    periodsData, setPeriodsData,
    resetAnalysisData,
    setAnalysisResults
  };
}

export default useAnalysisData;
